import React, { FC, Fragment, useState } from "react";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import StartRating from "components/StartRating/StartRating";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import LikeSaveBtns from "components/LikeSaveBtns";
import SectionDateRange from "../SectionDateRange";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { Amenities_demos, PHOTOS } from "./constant";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowRightIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonCircle from "shared/Button/ButtonCircle";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "../Layout";
import GuestsInput from "./GuestsInput";

import { STANZE_REALI } from "data/villaGrecoDatiStanze/stanze";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const googleMapsLink = process.env.REACT_APP_GOOGLEMAPSINDIRIZZO


const StayDetailPageContainer: FC = () => {
  const { id } = useParams<{ id: string }>(); // Ottieni l'ID della stanza
  const stanza = STANZE_REALI.find((item) => item.id === id); // Trova la stanza corrispondente

  let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);

  const thisPathname = useLocation().pathname;
  const router = useNavigate();

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }

  const handleOpenModalImageGallery = () => {
    if (stanza) {
      // router(`${thisPathname}/?modal=PHOTO_TOUR_SCROLLABLE&stanzaId=${stanza.id}`);
      router(`${thisPathname}/?modal=fotoGalleriaStanza&stanzaId=${stanza.id}`);
    } else {
      console.error("Stanza non trovata. Impossibile aprire il modale delle immagini.");
    }
  };
  

  if (!stanza) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h1 className="text-3xl font-bold text-red-500">Oops!</h1>
        <p className="text-lg text-neutral-700 mt-4">
          Non siamo riusciti a trovare l' appartamento che stavi cercando. 🛏️
        </p>
        <p className="text-neutral-500 mt-2 mb-5">
          Potrebbe essere stato rimosso o l'indirizzo potrebbe essere cambiato.
        </p>
        <ButtonPrimary href={"/"}>Torna alla Home</ButtonPrimary>
      </div>
    );
  }
  

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex justify-between items-center">
          <Badge name={stanza.title} />
          <LikeSaveBtns />
        </div>
  
        {/* Titolo */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {stanza.title}
        </h2>
  
        {/* Dettagli */}
        <div className="flex items-center space-x-4">
          <StartRating reviewCount={stanza.reviewCount} point={stanza.reviewStart} />
          <span>·</span>
          <a href={googleMapsLink} target="_blank" rel="noopener noreferrer">
            <span>
              <i className="las la-map-marker-alt"></i>
              <span className="ml-1">{stanza.address}</span>
            </span>
          </a>
        </div>
  
        {/* Informazioni sull'host */}
        <div className="flex items-center">
          <Avatar hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
          <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
            Hosted by{" "}
            <span className="text-neutral-900 dark:text-neutral-200 font-medium">
              {stanza.author.name}
            </span>
          </span>
        </div>
  
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />
  
        {/* Icone delle stanze dettagli */}
        <div className="flex flex-wrap mt-6 text-sm text-neutral-700 dark:text-neutral-300">
  <div className="flex items-center space-x-2 mr-4 mb-4">
    <i className="las la-user text-2xl"></i>
    <span>
      {stanza.maxGuests}{" "}
      <span className="hidden sm:inline-block">Persone</span>
    </span>
  </div>
  <div className="flex items-center space-x-2 mr-4 mb-4">
    <i className="las la-bath text-2xl"></i>
    <span>
      {stanza.bathrooms}{" "}
      <span className="hidden sm:inline-block">
        {stanza.bathrooms > 1 ? "Bagni" : "Bagno"}
      </span>
    </span>
  </div>
  <div className="flex items-center space-x-2 mr-4 mb-4">
    <i className="las la-bed text-2xl"></i>
    <span>
      {stanza.bedrooms}{" "}
      {/* <span className="hidden sm:inline-block"> */}
      <span className="">
        {stanza.bedrooms > 1 ? "Letti" : "Letto Matrimoniale"}
      </span>
    </span>
  </div>

{/* Mostra i letti singoli solo se presenti */}
{(stanza.lettiSingoli ?? 0) > 0 && (
  <div className="flex items-center space-x-2 mr-4 mb-4">
    <i className="las la-bed text-2xl"></i>
    <span>
      {stanza.lettiSingoli}{" "}
      {/* <span className="hidden sm:inline-block"> */}
      <span className="">
        {(stanza.lettiSingoli ?? 0) > 1 ? "Letti singoli" : "Letto singolo"}
      </span>
    </span>
  </div>
)}


  {/* Mostra il lettino extra solo se presente */}
  {(stanza.lettinoExtra ?? 0) > 0 && (
    <div className="flex items-center space-x-2 mr-4 mb-4">
      <i className="las la-plus-circle text-2xl"></i>
      <i className="las la-bed text-2xl"></i>
      <span>
        {stanza.lettinoExtra}{" "}
        {/* <span className="hidden sm:inline-block"> */}
      <span className="">
          Lettino su richiesta</span>
      </span>
    </div>
  )}
</div>
  
        {/* Optional */}
        {stanza.optional && stanza.optional.length > 0 && (
          <div className="flex flex-wrap mt-6 text-sm text-neutral-700 dark:text-neutral-300">
            {stanza.optional.map((opt, index) => (
              <div
                key={index}
                className="flex items-center space-x-2 mr-4 mb-4"
              >
                <i className={`${opt.icon} text-2xl`}></i>
                <span>{opt.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };
  

  const renderSection2 = () => (
    <div className="listingSection__wrap">
      {/* prima descrizione */}
      <h2 className="text-2xl font-semibold">Informazioni sull'Appartamento</h2>
      <p className="text-neutral-6000 dark:text-neutral-300">
  {stanza.description || `L'Appartamento "${stanza.title}" offre un'esperienza unica e confortevole.`}
</p>
      {/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>  */}
    {/* seconda descrizione */}
    <h2 className="text-1xl font-semibold">Lo spazio</h2>
      <p className="text-neutral-6000 dark:text-neutral-300">
  {stanza.description2 || `Non Disponibile`}
</p>
    {/* terza descrizione */}
    <h2 className="text-1xl font-semibold">Accesso per gli ospiti</h2>
      <p className="text-neutral-6000 dark:text-neutral-300">
  {stanza.description3 || `Non Disponibile`}
</p>


    {/* quarta descrizione */}
    {/* <h2 className="text-1xl font-semibold">Altre cose da tenere a mente</h2>
      <p className="text-neutral-6000 dark:text-neutral-300">
  {stanza.description4 || `Non Disponibile`}
</p> */}

{/* quarta descrizione */}
<h2 className="text-1xl font-semibold">Altre cose da tenere a mente</h2>
<div className="text-neutral-6000 dark:text-neutral-300">
  {stanza.description4
    ? stanza.description4.split("|").map((frase, index) => (
        <p key={index} style={{ marginBottom: "10px" }}>
          {frase.trim()}
        </p>
      ))
    : "Non Disponibile"}
</div>



    {/* quinta descrizione */}
    <h2 className="text-1xl font-semibold">Numero di registrazione</h2>
      <p className="text-neutral-6000 dark:text-neutral-300">
  {stanza.description5 || `Non Disponibile`}
</p>
    </div>
  );

  const renderSectionGallery = () => (
    <div className="listingSection__wrap">
      <h2 className="text-2xl font-semibold">Gallery</h2>
      <div className="grid grid-cols-2 gap-4">
        {stanza.galleryImgs.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Gallery image ${index + 1}`}
            className="rounded-lg"
          />
        ))}
      </div>
    </div>
  );
  

  const renderSection3 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Amenities </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {` About the property's amenities and services`}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
          {Amenities_demos.filter((_, i) => i < 12).map((item) => (
            <div key={item.name} className="flex items-center space-x-3">
              <i className={`text-3xl las ${item.icon}`}></i>
              <span className=" ">{item.name}</span>
            </div>
          ))}
        </div>

        {/* ----- */}
        <div className="w-14 border-b border-neutral-200"></div>
        <div>
          <ButtonSecondary onClick={openModalAmenities}>
            View more 20 amenities
          </ButtonSecondary>
        </div>
        {renderMotalAmenities()}
      </div>
    );
  };

  const renderMotalAmenities = () => {
    return (
      <Transition appear show={isOpenModalAmenities} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalAmenities}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      Amenities
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalAmenities} />
                    </span>
                  </div>
                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                    {Amenities_demos.filter((_, i) => i < 1212).map((item) => (
                      <div
                        key={item.name}
                        className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8"
                      >
                        <i
                          className={`text-4xl text-neutral-6000 las ${item.icon}`}
                        ></i>
                        <span>{item.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const renderSection4 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Room Rates </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Prices may increase on weekends or holidays
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* CONTENT */}
        <div className="flow-root">
          <div className="text-sm sm:text-base text-neutral-6000 dark:text-neutral-300 -mb-4">
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Monday - Thursday</span>
              <span>$199</span>
            </div>
            <div className="p-4  flex justify-between items-center space-x-4 rounded-lg">
              <span>Monday - Thursday</span>
              <span>$199</span>
            </div>
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Friday - Sunday</span>
              <span>$219</span>
            </div>
            <div className="p-4 flex justify-between items-center space-x-4 rounded-lg">
              <span>Rent by month</span>
              <span>-8.34 %</span>
            </div>
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Minimum number of nights</span>
              <span>1 night</span>
            </div>
            <div className="p-4 flex justify-between items-center space-x-4 rounded-lg">
              <span>Max number of nights</span>
              <span>90 nights</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSection5 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Host Information</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* host */}
        <div className="flex items-center space-x-4">
          <Avatar
            hasChecked
            hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
            sizeClass="h-14 w-14"
            radius="rounded-full"
          />
          <div>
            <a className="block text-xl font-medium" href="##">
              Kevin Francis
            </a>
            <div className="mt-1.5 flex items-center text-sm text-neutral-500 dark:text-neutral-400">
              <StartRating />
              <span className="mx-2">·</span>
              <span> 12 places</span>
            </div>
          </div>
        </div>

        {/* desc */}
        <span className="block text-neutral-6000 dark:text-neutral-300">
          Providing lake views, The Symphony 9 Tam Coc in Ninh Binh provides
          accommodation, an outdoor swimming pool, a bar, a shared lounge, a
          garden and barbecue facilities...
        </span>

        {/* info */}
        <div className="block text-neutral-500 dark:text-neutral-400 space-y-2.5">
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span>Joined in March 2016</span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
            <span>Response rate - 100%</span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>

            <span>Fast response - within a few hours</span>
          </div>
        </div>

        {/* == */}
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <ButtonSecondary href="/author">See host profile</ButtonSecondary>
        </div>
      </div>
    );
  };

  const renderSection6 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Reviews (23 reviews)</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* Content */}
        <div className="space-y-5">
          <FiveStartIconForRate iconClass="w-6 h-6" className="space-x-0.5" />
          <div className="relative">
            <Input
              fontClass=""
              sizeClass="h-16 px-4 py-3"
              rounded="rounded-3xl"
              placeholder="Share your thoughts ..."
            />
            <ButtonCircle
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
              size=" w-12 h-12 "
            >
              <ArrowRightIcon className="w-5 h-5" />
            </ButtonCircle>
          </div>
        </div>

        {/* comment */}
        <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
          <CommentListing className="py-8" />
          <CommentListing className="py-8" />
          <CommentListing className="py-8" />
          <CommentListing className="py-8" />
          <div className="pt-8">
            <ButtonSecondary>View more 20 reviews</ButtonSecondary>
          </div>
        </div>
      </div>
    );
  };

  const renderSection7 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Location</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            San Diego, CA, United States of America (SAN-San Diego Intl.)
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
        <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl z-0">
          <div className="rounded-xl overflow-hidden z-0">
            <iframe
              title="x"
              width="100%"
              height="100%"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAGVJfZMAKYfZ71nzL_v5i3LjTTWnCYwTY&q=Eiffel+Tower,Paris+France"
            ></iframe>
          </div>
        </div>
      </div>
    );
  };

  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Things to know</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Cancellation policy</h4>
          <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
            Refund 50% of the booking value when customers cancel the room
            within 48 hours after successful booking and 14 days before the
            check-in time. <br />
            Then, cancel the room 14 days before the check-in time, get a 50%
            refund of the total amount paid (minus the service fee).
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Check-in time</h4>
          <div className="mt-3 text-neutral-500 dark:text-neutral-400 max-w-md text-sm sm:text-base">
            <div className="flex space-x-10 justify-between p-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg">
              <span>Check-in</span>
              <span>08:00 am - 12:00 am</span>
            </div>
            <div className="flex space-x-10 justify-between p-3">
              <span>Check-out</span>
              <span>02:00 pm - 04:00 pm</span>
            </div>
          </div>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Special Note</h4>
          <div className="prose sm:prose">
            <ul className="mt-3 text-neutral-500 dark:text-neutral-400 space-y-2">
              <li>
                Ban and I will work together to keep the landscape and
                environment green and clean by not littering, not using
                stimulants and respecting people around.
              </li>
              <li>Do not sing karaoke past 11:30</li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          {/* <span className="text-3xl font-semibold">
            {stanza.price}
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /notte
            </span>
          </span> */}
          <div className="flex items-center">
          <Avatar hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
          <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
            Hosted by{" "}
            <span className="text-neutral-900 dark:text-neutral-200 font-medium">
              {stanza.author.name}
            </span>
          </span>
        </div>
          <StartRating />
        </div>

        {/* FORM */}
        {/* <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInput className="flex-1 z-[11]" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          <GuestsInput className="flex-1" />
        </form> */}

        {/* SUM */}
        <div className="flex flex-col space-y-4">
          {/* <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>{stanza.price} x 1 notte</span>
            <span>{stanza.price}</span>
          </div> */}
          {/* <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            <span>$0</span>
          </div> */}
          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          {/* <div className="flex justify-between font-semibold">
            <span>Totale</span>
            <span>{stanza.price}</span>
          </div> */}
          {/* <span>
            <p>nome host  o qualcosa di simile
            </p>
          </span> */}
          {/* Informazioni sull'host */}
        
        </div>

        {/* SUBMIT */}
        {/* <ButtonPrimary href={"/checkout"}>Reserve</ButtonPrimary> */}
        <ButtonPrimary href={"/contact"}>Contattaci</ButtonPrimary>
      </div>
    );
  };

  return (
    <div className="nc-ListingStayDetailPage">
      {/*  HEADER */}
      <header className="rounded-md sm:rounded-xl">
  <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
    <div
      className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
      onClick={handleOpenModalImageGallery}
    >
      <img
        className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
        src={stanza.galleryImgs[0]} // Mostra la prima immagine
        alt={stanza.title}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
      />
      <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
    </div>

    {stanza.galleryImgs.slice(1, 5).map((img, index) => ( // Mostra fino a 4 immagini successive
      <div
        key={index}
        className={`relative rounded-md sm:rounded-xl overflow-hidden ${
          index >= 3 ? "hidden sm:block" : ""
        }`}
      >
        <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
          <img
            className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
            src={img}
            alt={`${stanza.title} - ${index + 1}`}
            sizes="400px"
          />
        </div>

        {/* OVERLAY */}
        <div
          className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
          onClick={handleOpenModalImageGallery}
        />
      </div>
    ))}

    <button
      className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
      onClick={handleOpenModalImageGallery}
    >
      <Squares2X2Icon className="w-5 h-5" />
      <span className="ml-2 text-neutral-800 text-sm font-medium">
        Mostra tutte le foto
      </span>
    </button>
  </div>
</header>


      {/* MAIN */}
      <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderSection2()}
          {renderSectionGallery()}
          {/* {renderSection3()} */}
          {/* {renderSection4()} */}
          {/* <SectionDateRange /> */}
          {/* {renderSection5()} */}
          {/* {renderSection6()} */}
          {/* {renderSection7()} */}
          {/* {renderSection8()} */}
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>
    </div>
  );
};

export default function ListingStayDetailPage() {
  return (
    <DetailPagetLayout>
      <StayDetailPageContainer />
    </DetailPagetLayout>
  );
}
